<template>

  <div style="width: 100%;height: 100%;background-color: white" class="horizon-vertical-center">

    <el-row>
      <el-col :span="24" >
        <div class="horizon-vertical-center">
          <img src="../images/pic_logo.png" width="80">

<!--          <el-image :lazy="true" src="../images/pic_logo.png"></el-image>-->
        </div>
      </el-col>

      <el-col :span="24">
        <div class="horizon-vertical-center" style="margin-top: 20px">
          <span style="font-size: 36px">
          BP Doctor
        </span>
        </div>
      </el-col>

      <el-col :span="24">
        <div class="horizon-vertical-center" style="margin-top: 230px">
          <el-button @click="downloadApp" type="primary">
            未安装APP请先下载APP
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { isAndroid } from '../utils/util'

  export default {
    name: 'AppUniversal',
    mounted () {
      this.openApp()
    },
    methods: {
      openApp () {
        if (isAndroid()) {

        } else {
          window.location = 'com.health.yanhe://app?cmd=106'
        }
      },
      downloadApp () {
        if (isAndroid()) {

        } else {
          window.location.href = 'https://apps.apple.com/us/app/id1518354131'
        }
      }
    }
  }
</script>


<style scoped>

</style>
